import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Tabs } from 'antd';
import { GiftOutlined, HistoryOutlined } from '@ant-design/icons';
import { all_routes } from '../../../router/all_routes';
import CreateReferralCode from './components/CreateReferralCode';
import ReferralHistory from './components/ReferralHistory';
import FooterSection from '../../shared/components/footerSection';

const { TabPane } = Tabs;

// Mor tonlar için özel CSS
const referralProgramStyles = `
  .referral-program-tabs .ant-tabs-nav {
    margin-bottom: 24px;
  }
  .referral-program-tabs .ant-tabs-tab {
    font-size: 16px;
    font-weight: 600;
    padding: 12px 24px;
    border-radius: 8px 8px 0 0;
    transition: all 0.3s ease;
  }
  .referral-program-tabs .ant-tabs-tab:hover {
    color: #7338a1;
  }
  .referral-program-tabs .ant-tabs-tab-active {
    color: #7338a1;
    font-weight: 700;
  }
  .referral-program-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #7338a1;
  }
  .referral-program-tabs .ant-tabs-ink-bar {
    background: linear-gradient(135deg, #7338a1 0%, #9d4edd 100%);
    height: 3px;
  }
  .referral-program-card {
    border-radius: 16px;
    border: none;
    box-shadow: 0 4px 16px rgba(115, 56, 161, 0.1);
    overflow: hidden;
  }
  .referral-program-card .ant-card-body {
    padding: 24px;
  }
`;

const ReferralProgram: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('create');

  return (
    <>
      <style>{referralProgramStyles}</style>
      {/* Page Wrapper */}
      <div className="page-wrapper vh-100 d-flex flex-column justify-content-between">
        <div className="content flex-fill h-100">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-4">
            <div className="my-auto mb-2">
              <h2 className="mb-1" style={{ color: '#7338a1', fontWeight: 'bold' }}>
                <GiftOutlined style={{ color: '#7338a1', marginRight: '8px' }} />
                Referans Programı
              </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Referans Programı
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Breadcrumb */}

          <Card className="referral-program-card">
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              type="line"
              size="large"
              className="referral-program-tabs"
            >
              <TabPane
                tab={
                  <span>
                    <GiftOutlined />
                    Davet Kodu Oluştur
                  </span>
                }
                key="create"
              >
                <CreateReferralCode />
              </TabPane>
              
              <TabPane
                tab={
                  <span>
                    <HistoryOutlined />
                    Referans Geçmişim
                  </span>
                }
                key="history"
              >
                <ReferralHistory />
              </TabPane>
            </Tabs>
          </Card>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <FooterSection />
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default ReferralProgram;

